// extracted by mini-css-extract-plugin
export default {"buttons-group":"styles_buttons-group__iXRl+","button":"styles_button__DGgCK"};